<script setup lang="ts">
import { nxAnnouncerMessages, useNxAnnouncerPresence } from './announcer';

/**
 * The app's shared, visually hidden live regions — mount it ONCE near the root
 * (next to the toast host). `useNxAnnounce().announce(text)` speaks through it.
 */
const { isActive } = useNxAnnouncerPresence();
const { polite, assertive } = nxAnnouncerMessages;
</script>

<template>
  <div v-if="isActive()" class="nx-live-announcer" data-testid="nx-live-announcer">
    <div aria-live="polite" aria-atomic="true" data-nx-announcer-region="polite">
      {{ polite }}
    </div>
    <div aria-live="assertive" aria-atomic="true" data-nx-announcer-region="assertive">
      {{ assertive }}
    </div>
  </div>
</template>

<style scoped>
.nx-live-announcer {
  position: absolute;
  width: var(--nxt-hairline);
  height: var(--nxt-hairline);
  padding: 0;
  margin: calc(var(--nxt-hairline) * -1);
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
